<template>
  <footer class="caixa-flutuante-inferior" :style="'height:' + altura + 'px;' + estilo">
    <slot></slot>
  </footer>
</template>

<script>
export default {
  name: "CaixaFlutuanteInferior",
  props: ["altura", "estilo"]
};
</script>

<style scoped>
.caixa-flutuante-inferior {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  width: 100%;
  padding: 0.5rem 1rem;
  box-shadow: rgba(48, 51, 60, 0.25) 0px -1px 2px;
  margin: 0px auto;
  z-index: 999;
  color: white;
}
</style>

<!--<template>-->
<!--  <div :style="'padding-top: 100px;'">-->
<!--    <footer class="caixa-flutuante-inferior" :style="'height:' + altura + 'px;' + '' + estilo">-->
<!--      <slot></slot>-->
<!--    </footer>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--  export default {-->
<!--    name: "CaixaFlutuanteInferior",-->
<!--    props:["altura","fundo","estilo"]-->
<!--  }-->
<!--</script>-->

<!--<style scoped>-->
<!--  .caixa-flutuante-inferior {-->
<!--    display: flex;-->
<!--    -webkit-box-pack: justify;-->
<!--    justify-content: space-between;-->
<!--    position: fixed;-->
<!--    bottom: 0px;-->
<!--    left: 0px;-->
<!--    right: 0px;-->
<!--    width: 100%;-->
<!--    background-color: rgb(255, 255, 255);-->
<!--    padding: 0.75rem 1rem;-->
<!--    box-shadow: rgba(48, 51, 60, 0.25) 0px -1px 2px;-->
<!--    max-width: 800px;-->
<!--    margin: 0px auto;-->
<!--    z-index: 1060;-->
<!--  }-->
<!--</style>-->



// WEBPACK FOOTER //
// src/app/components/CaixaFlutuanteInferior.vue